import React, { Component } from "react";
import Modal from "../../../UIComponents/CustomModal/Modal";
import { IconUrls } from "../../../../lib/staticFileUrls";

import "./ReplyModal.css";

class ReplyModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let userTimezone = JSON.parse(localStorage.getItem("company")).user_timezone_name;

        return (
            <Modal width="75%" className="replys-modal" show={this.props.open} onClose={() => this.props.hideModal()}>
                <Modal.Header>
                    CONVERSATION THREAD
                    {this.props.replysLoading && <span className="replys-count"> Loading ... </span>}
                    {!this.props.replysLoading && this.props.replys && this.props.replys.length !== undefined && (
                        <span className="replys-count"> {this.props.replys.length} Replys </span>
                    )}
                </Modal.Header>
                <Modal.Content>
                    {this.props.postInfo.postImg && this.props.postInfo.postImg !== "" && <img className="post-image" src={this.props.postInfo.postImg} />}
                    <section className="content">
                        {this.props.postInfo && (
                            <div className="header">
                                <img className="author-image" src={this.props.postInfo.postAuthorImg} />
                                <span className="post-author"> {this.props.postInfo.postAuthor} </span>
                                <span className="post-time">
                                    {" "}
                                    {this.props.postInfo.postTime && this.props.postInfo.postTime[1]} {userTimezone}{" "}
                                </span>
                                {this.props.postInfo.postSentiment && (
                                    <img
                                        src={IconUrls[`${this.props.postInfo.postSentiment.toLowerCase()}-sentiment`]}
                                        alt="neutral"
                                        className="post-sentiment"
                                    />
                                )}
                            </div>
                        )}
                        {this.props.postInfo && (
                            <div className="post-content">
                                <p className="content"> {this.props.postInfo.post} </p>
                                <a className="view-more" target="_blank" rel="noreferrer" href={this.props.postInfo.postLink}>
                                    {" "}
                                    VIEW MORE{" "}
                                </a>
                            </div>
                        )}
                    </section>
                    {this.props.replysLoading && <span className="info"> Loading replies </span>}

                    {!this.props.replysLoading && this.props.replys && this.props.replys.length === 0 && (
                        <span className="info"> Replies haven&apos;t been pulled for this post yet. </span>
                    )}
                    <div className="replys">
                        {!this.props.replysLoading &&
                            this.props.replys &&
                            this.props.replys.length > 0 &&
                            this.props.replys.map((post, i) => (
                                <div className="reply" key={i}>
                                    <div className="header">
                                        {post.postImg && post.postImg !== "" && <img className="author-image" src={post.postAuthorImg} />}
                                        <span className="post-author"> {post.postAuthor} </span>
                                        <span className="post-time"> {post.postTime && post.postTime[1]} </span>
                                        <img src={IconUrls[`${post.postSentiment.toLowerCase()}-sentiment`]} alt="neutral" className="post-sentiment" />
                                    </div>
                                    <div className="post-content">
                                        <p className="content"> {post.post} </p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </Modal.Content>
            </Modal>
        );
    }
}

export default ReplyModal;
